"use client";
import "./chunk-N3ETBM74.js";
import { useCallback } from "react";
import {
  InteractionStatus
} from "@azure/msal-browser";
import { useMsal } from "@azure/msal-react";
import { msalAuthSettings } from "./msal";
import { stashPostLoginTarget } from "./postLoginTarget";
import { updateSession } from "./utils";
import { secondaryMarkets } from "@dfds-pax/utils";
const loginRedirect = async (instance, locale, returnTo) => {
  const localeLower = locale.toLowerCase();
  const _locale = secondaryMarkets.includes(localeLower) ? "en" : locale;
  stashPostLoginTarget(returnTo);
  const params = {
    extraQueryParameters: { ui_locales: _locale },
    scopes: msalAuthSettings.scopes
  };
  await instance.loginRedirect(params);
};
const useSessionContinue = ({ locale }) => {
  const { inProgress, instance } = useMsal();
  const establishSession = useCallback(
    async (options) => {
      if (inProgress !== InteractionStatus.None) return "busy";
      let accessToken;
      let account;
      try {
        const result = await instance.acquireTokenSilent({ scopes: msalAuthSettings.scopes });
        accessToken = result.accessToken;
        account = result.account;
      } catch (e) {
        if (options == null ? void 0 : options.interactive) {
          await loginRedirect(instance, locale, options.returnTo);
          return "redirecting";
        }
        return "unauthenticated";
      }
      instance.setActiveAccount(account);
      await updateSession(accessToken);
      return "authenticated";
    },
    [inProgress, instance, locale]
  );
  return { establishSession, ready: inProgress === InteractionStatus.None };
};
export {
  useSessionContinue
};
